import React, { useState, useEffect } from 'react';
import CommentFormSection from '../forms/CommentFormSection';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import axios from 'axios';
const apiUrl = import.meta.env.VITE_API_URL;

const PageDetailSection = () => {
    const [t, i18n] = useTranslation();
    const [page, setPage] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { slug_en } = useParams();
  
    useEffect(() => {
      fetchPageDetails(slug_en);
    }, [slug_en]);
  
    const fetchPageDetails = (slug_en) => {
      fetch(`${apiUrl}/api/page/${slug_en}`)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to fetch page details');
          }
        })
        .then(data => {
          setPage(data);
          setLoading(false);
        })
        .catch(error => {
          setError(error.message);
          setLoading(false);
        });
    };
  
    if (loading) {
      return (
        <div className="container">
          <div className="loading-spinner" style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '50vh' 
          }}>
            <div style={{
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #000000',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              animation: 'spin 1s linear infinite'
            }}></div>
            <style>{`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}</style>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="container">
          <div className="error-message" style={{ 
            textAlign: 'center', 
            padding: '20px', 
            color: 'red' 
          }}>
            <p>{error}</p>
          </div>
        </div>
      );
    }
    
    return (
      <div className="container">
        <main className="blog-page-content">
          <div className="pages-container fz-blog-details-container">
            <div className="blogs">
              <div className="fz-single-blog fz-inner-page-blog fz-blog-details">
                <div className="fz-single-blog__img fz-blog-details__img">
                  <img 
                    src={`${apiUrl}/uploads/${page.image}`} 
                    alt={i18n.language === 'ar' ? page.title_ar : page.title_en} 
                  />
                  <div className="fz-blog-details__heading">
                    <h3 className="fz-single-blog__title fz-blog-details__title">
                      {i18n.language === 'ar' ? page.title_ar : page.title_en}
                    </h3>
                  </div>
                </div>
                <div className="fz-single-blog__txt fz-blog-details__txt">
                  <div
                    className="fz-single-blog__desc fz-blog-details__descr"
                    dangerouslySetInnerHTML={{
                      __html: i18n.language === 'ar' ? page.description_ar : page.description_en,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
}

export default PageDetailSection;